module.exports = __webpack_public_path__ + "static/media/personToPerson.8835be2c.svg";